import { FC } from 'react';

import ButtonStyled, { PropsButtons } from './styles';

const Button: FC<PropsButtons> = ({ children, ...props }) => {
  return <ButtonStyled {...props}>{children}</ButtonStyled>;
};

export default Button;
